export function union(arg) {
    return function (acc, rule, index, arr) {
        const result = rule.buildPatterns(arg);
        let whereClause;
        if (index === 0 && arr.length === 1) {
            whereClause = [groupPatterns(result.whereClause)];
        }
        else {
            const group = groupPatterns(result.whereClause);
            let union;
            if (acc.whereClause.length === 1 && acc.whereClause[0].type === 'union') {
                union = acc.whereClause[0];
            }
            else {
                union = {
                    type: 'union',
                    patterns: [],
                };
            }
            union.patterns.push(group);
            whereClause = [union];
        }
        return {
            constructClause: [...acc.constructClause, ...result.constructClause],
            whereClause,
            childPatterns: [...acc.childPatterns, ...result.childPatterns || []],
        };
    };
}
function groupPatterns(patterns) {
    if (patterns.length === 1 && patterns[0].type === 'group') {
        return patterns[0];
    }
    return {
        type: 'group',
        patterns,
    };
}
